/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A secure sign-in layer for Minecraft communities, with web, OAuth, and passkey authentication.`)
};

const zh_hans1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为 Minecraft 社区提供安全登录层，支持网页、OAuth 与通行密钥认证。`)
};

const zh_hant1_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為 Minecraft 社群提供安全登入層，支援網頁、OAuth 與通行金鑰驗證。`)
};

const fr_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une couche de connexion sécurisée pour les communautés Minecraft, avec authentification web, OAuth et passkeys.`)
};

const de_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine sichere Anmeldeschicht für Minecraft-Communities mit Web-, OAuth- und Passkey-Authentifizierung.`)
};

const ja_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft コミュニティ向けの安全なサインイン基盤。Web、OAuth、パスキー認証に対応します。`)
};

const ko_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 커뮤니티를 위한 안전한 로그인 계층으로, 웹, OAuth, 패스키 인증을 지원합니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_hero_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_hero_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_hero_subtitle", locale)
	if (locale === "en") return en_home_hero_subtitle(inputs)
	if (locale === "zh-Hans") return zh_hans1_home_hero_subtitle(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_hero_subtitle(inputs)
	if (locale === "fr") return fr_home_hero_subtitle(inputs)
	if (locale === "de") return de_home_hero_subtitle(inputs)
	if (locale === "ja") return ja_home_hero_subtitle(inputs)
	return ko_home_hero_subtitle(inputs)
};